export default "__VITE_ASSET__D3qeuf1I__"